<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      Gestion administration
    </div>
  </dxi-item>
</dx-toolbar>

<div class="d-flex p-4 align-items-center" style="justify-content: flex-start">
  <div class="pr-4">Purge des articles inactifs</div>
  <div>
    <dx-button
      stylingMode="contained"
      text="Cliquez ici"
      type="default"
      [width]="120"
      (onClick)="showPopupPurge()"
    ></dx-button>
  </div>
</div>

<div class="d-flex p-4 align-items-center" style="justify-content: flex-start">
  <div class="pr-4">Mise à jour des allergènes</div>
  <div>
    <dx-button
      stylingMode="contained"
      text="Cliquez ici"
      type="default"
      [width]="120"
      (onClick)="showPopupAllergenes()"
    ></dx-button>
  </div>
</div>

<div class="d-flex p-4 align-items-center" style="justify-content: flex-start">
  <div class="pr-4">Mise à jour des produits articles</div>
  <div>
    <dx-button
      stylingMode="contained"
      text="Cliquez ici"
      type="default"
      [width]="120"
      (onClick)="showPopupMAJProduitsArticles()"
    ></dx-button>
  </div>
</div>

<div class="d-flex p-4 align-items-center" style="justify-content: flex-start">
  <div class="pr-4">Mise à jour des factures fournisseurs</div>
  <div>
    <dx-button
      stylingMode="contained"
      text="Cliquez ici"
      type="default"
      [width]="120"
      (onClick)="showPopupMAJBills()"
    ></dx-button>
  </div>
</div>

<div class="d-flex p-4 align-items-center" style="justify-content: flex-start">
  <div class="pr-4">Mise à jour des articles avec les périodes de prix</div>
  <div>
    <dx-button
      stylingMode="contained"
      text="Cliquez ici"
      type="default"
      [width]="120"
      (onClick)="showPopupMAJArticlesWithPeriodPrice()"
    ></dx-button>
  </div>
</div>

<dx-popup
  [width]="500"
  [height]="'auto'"
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="popupPurgeVisible"
  [resizeEnabled]="true"
  (onHiding)="closeDialogPurge()"
>
  <div>
    <p>
      Êtes-vous sûr de vouloir supprimer les articles inactifs ?
    </p>
    <p>
      Cela entraînera également :
    </p>
    <ul>
      <li>l'historique des lignes de commandes dans lesquelles sont utilisées les articles</li>
      <li>les lignes des listes de besoins</li>
      <li>les articles en stock</li>
      <li>l'historique des sorties pour production</li>
      <li>l'éventuelle liaison avec les lots marchés</li>
    </ul>
    <p>
      Cette action est irréversible.
    </p>
  </div>
  <div class="p-2 d-flex justify-content-end">
    <button
      class="btn btn-primary"
      type="button"
      (click)="purgeInactiveArticles()">
      Confirmer
    </button>
  </div>
</dx-popup>

<dx-popup
  [width]="500"
  [height]="'auto'"
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="popupAllergenesVisible"
  [resizeEnabled]="true"
  (onHiding)="closeDialogAllergenes()"
>
  <div>
    <p>
      Êtes-vous sûr de vouloir mettre à jour les allergènes sur tous les plats ?
    </p>
    <p>
      Cette action peut prendre quelques minutes.
    </p>
  </div>
  <div class="p-2 d-flex justify-content-end">
    <button
      class="btn btn-primary"
      type="button"
      (click)="majAllergenes()">
      Confirmer
    </button>
  </div>
</dx-popup>

<dx-popup
  [width]="500"
  [height]="'auto'"
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="popupMAJProduitsArticlesVisible"
  [resizeEnabled]="true"
  (onHiding)="closeDialogMAJProduitsArticles()"
>
  <div>
    <p>
      Êtes-vous sûr de vouloir mettre à jour les produits articles ?
    </p>
  </div>
  <div class="p-2 d-flex justify-content-end">
    <button
      class="btn btn-primary"
      type="button"
      (click)="updateProduitsArticles()">
      Confirmer
    </button>
  </div>
</dx-popup>

<dx-popup
  [width]="500"
  [height]="'auto'"
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="popupMAJBillsVisible"
  [resizeEnabled]="true"
  (onHiding)="closeDialogMAJBills()"
>
  <div>
    <p>
      Êtes-vous sûr de vouloir mettre à jour les factures fournisseurs ?
    </p>
  </div>
  <div class="p-2 d-flex justify-content-end">
    <button
      class="btn btn-primary"
      type="button"
      (click)="updateBills()">
      Confirmer
    </button>
  </div>
</dx-popup>

<dx-popup
  [width]="500"
  [height]="'auto'"
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="popupMAJArticlesWithPeriodPriceVisible"
  [resizeEnabled]="true"
  (onHiding)="closeDialogMAJArticlesWithPeriodPrice()"
>
  <div>
    <p>
      Êtes-vous sûr de vouloir mettre à jour les articles avec les périodes de prix ?
    </p>
  </div>
  <div class="p-2 d-flex justify-content-end">
    <button
      class="btn btn-primary"
      type="button"
      (click)="updateArticlesWithPeriodPrice()">
      Confirmer
    </button>
  </div>
</dx-popup>

<yo-gestion-authentification></yo-gestion-authentification>
